import map from 'lodash/map'
import React from 'react'
import { useError, useMutation } from '@ztechapps/common.hook'
import type { SelectOption } from '@ztechapps/webui.input'
import type { Product, ProductBillOfMaterial } from '@ztechapps/common.contract'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { createProduct_billOfMaterials_with_parent_product } from './graphql'
import { useBillOfMaterialsContext } from './Context'
import { ProductSelectCreatable } from '../ProductSelect/ProductSelectCreatable'

export type NewProps = { productId: string; billOfMaterials: ProductBillOfMaterial[] }
export const NewBom = ({ productId, billOfMaterials }: NewProps) => {
  const context = useBillOfMaterialsContext()
  const parentProductId = context.product?._id
  const [product, setProduct] = React.useState(null)
  const [onAdd, , { loading }] = useMutation<
    { createProduct_billOfMaterials_with_parent_product: Product },
    Partial<ProductBillOfMaterial>
  >({
    query: createProduct_billOfMaterials_with_parent_product,
  })

  //should exclude products that are already in the bill of materials
  const selectFilter = React.useMemo(() => {
    let _ids = map(billOfMaterials, (e) => e?.product?._id)
    _ids = [..._ids, productId]
    return { _id: { $nin: _ids }, status: 'Active' }
  }, [billOfMaterials, productId])

  const { onError } = useError()

  async function addBom(product: Product) {
    try {
      if (!product) {
        //dont process anything if there is no value for product
        return
      }
      //we need to check firs the if it is should be create
      const billOfMaterial = { product: { _id: product?._id, code: product?.code }, quantity: 1, requiredToBuild: true }

      await onAdd({ input: billOfMaterial, filter: { _id: productId, parentProductId } })
      setProduct(null) //clears the product select
    } catch (e) {
      onError(e)
    }
  }

  const { canEdit } = useBillOfMaterialsContext()

  return (
    <ShowIf condition={canEdit}>
      <HorizontalStack gap={0}>
        <div className="flex-fill">
          <ProductSelectCreatable
            compact={true}
            onChange={(e: SelectOption) => {
              setProduct(e)
              addBom(e as unknown as Product)
            }}
            isDisabled={loading}
            value={product}
            filter={selectFilter}
          />
        </div>
      </HorizontalStack>
    </ShowIf>
  )
}
